<adapt-menu [items]="menuItems"
            orientation="vertical"></adapt-menu>
